// @ts-ignore
import React from "react";
import Skeleton from "../Skeleton.tsx";

export default function EventPageSkeleton() {
  return (
    <div className="absolute w-full inset-y-12 overflow-y-auto z-10 px-4 py-4 mt-12">
      <div className="bg-gray-400 backdrop-blur-lg border border-white/30 w-full p-6 py-12 rounded-lg shadow-sm">
        <Skeleton className="h-4 w-1/3 mb-4" />
        {/*Image Section */}
        <Skeleton className="sm:w-1/5 w-full h-52 mb-4" />
        <Skeleton className="h-8 w-full mb-2" />
        <Skeleton className="h-6 w-3/4 mb-2" />
        <Skeleton className="h-14 w-full mb-2" />
        {/*Icon Section */}
        <Skeleton className="h-24 w-3/5 my-6" />
        <Skeleton className="h-6 w-fullw-full mb-2" />
        <Skeleton className="h-12 w-full mb-2" />
      </div>
    </div>
  );
}
